<template>
  <div class="mw-panel mw-tree-select">
    <div class="mw-tree-search" v-if="search">
      <el-input
        placeholder="请输入搜索内容"
        v-model="searchText"
        clearable>
      </el-input>
    </div>
    <div :class="{'mw-tree-search__body':search,'mw-tree-no-search__body':!search}">
      <div class="mw-tree">

      </div>
    </div>
  </div>
</template>
<script>
  import token from '../../../utils/token'
  export default {

    name: 'MwTree',
    props: {
      ajaxType:{
        type:String,
        default:'GET'
      },
      search:{
        type: Boolean,
        default: false
      },
      restful:{
        type: Boolean,
        default: false
      },
      //是否自动加载
      autoLoad:{
        type: Boolean,
        default: true
      },
      //默认的根节点条件
      defaultParentId:{
        type: String
      },
      //默认参数
      defaultParams:{
        type: Object
      },
      changeDefaultParams: {
        type:Function
      },
      reload: {
        type: Boolean,
        default: true
      },
      //参数ID别名
      aliasId:{
        type: String,
        default: 'nodeId'
      },
      //加载数据地址
      url: {
        type: String
      },
      //是否打开第一个节点
      expandedFirst: {
        type: Boolean,
        default: false
      },
      selectFirst: {
        type: Boolean,
        default: false
      },
      //是否异步加载
      async: {
        type: Boolean,
        default: false
      },
      //是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      singleLeaf: {
        type: Boolean,
        default: false
      },
      //父结点选择把所有子结点自动选中
      parentSelChildren:{
        type: Boolean,
        default: false
      },
      //多选是否只选最子节点
      multipleLeaf: {
        type: Boolean,
        default: false
      },
      contextMenuItem: {
        type: Array,
        default: function () {
          return [];
        }
      },
      dragEnable: {
        type: Boolean,
        default: false
      },

      threeState: {
        type: Boolean,
        default: false
      },
      forceText: {
        type: Boolean,
        default: true
      },
      //多选时选中的ID
      checkNodes: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //单选选中ID
      selectNode: {
        type: String,
        default: ''
      },
      checkCallback:{
        type:Function,
        default: function (operation, node, node_parent, node_position, more) {
          return true;
        }
      },
      types:{
        type:Object
      },
      // 静态数据
      treeData: {
        type: [Array,Object]
      },

      paramsAnalyze:{
        type:Function
      }
    },
    data() {
      return {
        propTreeData:this.treeData,
        propDefaultParams:this.defaultParams,
        propAsyncLoadOnce:false,
        searchFlag:false,
        searchText:'',
        selectData: {},
        selectParents: [],
        selecteNodeIds:[]
      }
    },
    watch: {
      checkNodes(newIds) {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        try{
          inst.uncheck_all();
          newIds.forEach(id => {
            let obj = inst.get_node(id);
            inst.check_node(obj);
          })
        }catch (e){}

      },
      selectNode(newId) {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        try{
          inst.deselect_all();
          if (newId) {
            let obj = inst.get_node(newId);
            inst.select_node(obj);
          }
        }catch (e){}
      },
      searchText(val){
        this.searchTree(val);
      },
      url(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      },
      defaultParams(val){
        this.propDefaultParams=val
        if(this.reload){
          let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
          if(tree){
            tree.destroy();
          }
          this.renderTree();
        }
      },
      defaultParentId(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      },
      treeData(val){
        this.propTreeData=val;
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      },
      paramsAnalyze(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      }
    },
    mounted() {
      if(this.autoLoad){
        this.renderTree();
      }
    },
    destroyed() {
      let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
      if(tree){
        tree.destroy();
      }
    },
    methods: {
      searchTree(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true)
          if(val==''){
            setTimeout(function() {
              try{
                tree.clear_search()
              }catch (e){}
            }, 250);
          }else{
            if (this.searchFlag) {
              clearTimeout(this.searchFlag)
            }
            this.searchFlag = setTimeout(function() {
              tree.search(val,true,true)
            }, 250);
          }

      },
      checkAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.select_all();
      },
      unCheckAll() {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
      },
      openAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('open_all');
      },
      openNode(openId) {
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let n = inst.get_node(openId);
        inst.open_node(n);
      },
      closeAll() {
        $(this.$el.querySelector('.mw-tree')).jstree('close_all');
      },
      refresh() {
        //由于IE刷新get请求还是拿缓存数据，刷新改下以方法
        //$(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          let selected = tree.get_selected();
          this.selecteNodeIds = [];
          if (!this.multiple && selected.length > 0) {
            this.setSelectNodeIds(selected[0],tree);
          }
          tree.destroy();
        }
        this.renderTree();
      },
      setSelectNodeIds(nodeId,inst){
        var me = this;
        me.selecteNodeIds.push(nodeId);
        let node = inst.get_node(nodeId);
        let parents = node.parents;
        if(parents && parents.length > 1){
          for(var i=0;i< parents.length-1;i++){
            me.selecteNodeIds.push(parents[i]);
          }
        }
      },
      setCheckNodes(newIds) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.uncheck_all();
        newIds.forEach(id => {
          let obj = inst.get_node(id);
          inst.check_node(obj);
        })
      },
      setSelectNode(newId) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
        if (newId) {
          let obj = inst.get_node(newId);
          inst.select_node(obj);
        }
      },
      refreshTreeData(val){
        this.propTreeData=val;
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      },
      refreshData(data){
        $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      getNode(id){
        return $(this.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
      },
      getSelected() {
        var me = this;
        let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        let selected = tree.get_selected();

        let data=[];
        if (this.multiple) {
          if (selected.length > 0) {
            data = [];
            selected.forEach(id => {
              var obj = tree.get_node(id);
              //多选叶子结点，父结点选择把所有子结点自动选中，选中数据把父结点过虑掉
              if(!(me.multipleLeaf && me.parentSelChildren && obj.children && obj.children.length>0)){
                data.push(obj.original);
              }
            });
          }
        } else {
          if (selected.length > 0) {
            data = tree.get_node(selected[0]).original;
          }else{
            return undefined;
          }
        }
        return data;
      },
      getTree() {
        return $(this.$el.querySelector('.mw-tree')).jstree(true);
      },
      getTreeData(){
        let tree = this.getTree();
        return tree.get_json();
      },

      editNodeName(selectNode,parentId){
          let tree = this.getTree();
          let clickedNode = tree.get_node(selectNode);
          tree.edit(clickedNode);
      },
      setNodeText(node,text) {
        this.getTree().set_text(node,text);
      },
      deleteNode(selectNode,callback){
          let tree = this.getTree();
          let clickedNode = tree.get_node(selectNode);
          tree.delete_node(clickedNode);
          if(typeof callback === 'function'){
              callback();
          }
      },

      createNode(selectNode,node,position,callback){
         let tree = this.getTree();
         let id=tree.create_node(selectNode, node, position);
         return tree.get_node(id);
      },

      // 清空搜索框
      resetSearchText(){
        this.searchText = '';
      },

      changeMenuItem(data) {
        let me = this;
        if (me.contextMenuItem.length > 0) {
          let items = {};
          me.contextMenuItem.forEach(item => {
            items[item.name] = {
              "name": item.name ? item.name : '',
              "label": item.label,
              "icon": item.icon ? item.icon : '',
              "action": function (a) {
                item.func(me.selectData, me.selectParents, a.item, a);
              }
            }
          });
          return items;
        } else {
          let items = {};
          this.$emit('changeItem', data, function (d) {
            items = d;
          })
          return items;
        }
      },

      renderTree() {

        let me = this, jsTreeEl = $(me.$el.querySelector('.mw-tree'));

        let plugin = ["types"];
        let items = {};
        if (me.multiple) {
          plugin.push("checkbox");
          plugin.push("wholerow");
        } else {
          plugin.push("wholerow");
        }
        let types={"#": {
          "icon": "fa fa-folder"
        },
          "file": {
            "icon": "fa fa-leaf"
          },
          "default": {
            "icon": "fa fa-folder"
          }}
        if(me.types){
          types=me.types;
        }

        if(!this.dragEnable){
          plugin.push("dnd");
        }
        if(me.search){
          plugin.push("search");
        }
        /*if (me.contextMenuItem.length > 0) {
          plugin.push("contextmenu");
          me.contextMenuItem.forEach(item => {
            items[item.name] = {
              "name": item.name ? item.name : '',
              "label": item.label,
              "icon": item.icon ? item.icon : '',
              "action": function (a) {
                item.func(me.selectData, me.selectParents,a.item,a);
              }
            }
          });
        }else{
          plugin.push("contextmenu");
        }*/
        plugin.push("contextmenu");
        let data = {};

        function changeTreeData(data) {
          data.forEach(d => {
            if (undefined==d.text) {
              if (d.name!=undefined)
                d.text = d.name;
            }
            if (d.children) {
              if (!d.hasChild) {
                d.hasChild = d.children.length;
              }
              if (d.children.length > 0) {
                changeTreeData(d.children);
              }
            } else {
              d.children = false;
              d.hasChild = 0;
            }
            if (d.hasChild > 0) {
              if (me.multiple && me.multipleLeaf && !me.parentSelChildren) {
                d.state = {"disabled": true};
              }
            }
            if(!d.id){
              d.id=d.text
            }
          })
        }

        if (me.propTreeData) {
          let cdata=[];
          me.propTreeData.forEach(v=>{
            let v1={};
            this.mwLodash.assign(v1,v);
            cdata.push(v1)
          })
          changeTreeData(cdata);
          data = cdata;
        } else {
          var url = me.url;
          if(url.indexOf("?")==-1){
            url=url+"?t="+Date.now();
          }else if(url.indexOf("?t=") ==-1 && url.indexOf("&t=") ==-1){
             url=url+"&t="+Date.now();
          }
          data = {
          /*  beforeSend:function(xhr){
              xhr.setRequestHeader('Authorization', 'Bearer ' + token.getToken());
            },*/
            "url":me.ajaxType=='GET' ? function (node) {
              if(me.async){
                let sendData=undefined;
                if(node.id!='#'){
                  sendData=node.original;
                  if(me.changeDefaultParams){ //改变默认参数
                    var tempDefaultParams=me.changeDefaultParams(sendData);
                    if(tempDefaultParams){
                      let arr = [];
                      for (let p in tempDefaultParams) {
                        arr.push(p + "=" + tempDefaultParams[p]);
                      }
                      if(node.id != '#'){
                        arr.push(me.aliasId+"="+node.id);
                      }
                      return url + '&'+arr.join("&");
                    }
                  }
                }
              }
              if(me.propDefaultParams) {
                let arr = [];
                for (let p in me.propDefaultParams) {
                  arr.push(p + "=" + encodeURIComponent(me.propDefaultParams[p]));
                }
                if(node.id != '#'){
                  arr.push(me.aliasId+"="+node.id);
                }
                return url + '&'+arr.join("&");
              }
              //新tomcat不支持传参'['，加encodeURIComponent;
              if (node.id === '#') {
                if(me.defaultParentId){
                  return url + '&args='+encodeURIComponent('['+me.defaultParentId+']');
                }
                return url + '&args='+encodeURIComponent('[null]');
              } else {
                return url + '&args='+encodeURIComponent('[' + node.id + ']');
              }
            }:url,
            type:me.ajaxType,
            'data': function (node) {
              if(me.ajaxType=="GET"){
                return;
              }else{
                if(me.paramsAnalyze){
                  return me.paramsAnalyze(node,me);
                }else{
                  return _.assign(me.defaultParams,{'id': node.id});
                }
              }
            },
            dataFilter: function (data) {
              var json = JSON.parse(data);
              var data = json.result;
              if(me.restful){
                data=json;
              }

              if (data) {
                if (me.async) {
                  data.forEach(d => {
                    if(!me.propAsyncLoadOnce && d.children){
                      me.propAsyncLoadOnce=true;
                    }

                    if (undefined==d.text) {
                      if (d.name!=undefined)
                        d.text = d.name;
                    }
                    if (d.children) {
                      changeTreeData(d.children);
                      if (!d.hasChild) {
                        d.hasChild = d.children.length;
                      }
                    } else {
                      if (d.hasChild) {
                        if (!d.children) {
                          if (d.hasChild > 0) {
                            d.children = true;
                          } else {
                            d.children = false;
                          }
                        }
                      } else {
                        if(!(d.type!='' && me.types)) {
                          d.type = 'file';
                        }
                        d.children = false;
                        d.hasChild = 0;
                      }
                    }
                    if(!d.id){
                      d.id=d.text
                    }
                  })
                } else {
                  changeTreeData(data);
                }
              } else {
                data = [];
              }
              if(me.selecteNodeIds.length===0){
                me.$emit("dataAfterLoaded",data);  //刷新最后一次数据才触发
              }
              me.$emit("dataFilter",data);
              return JSON.stringify(data);
            },


            "success": function (data) {
              return data;
            }
          }
        }

        jsTreeEl.data('jstree', false).empty();
        jsTreeEl.jstree({
          'async': me.async, //url 是一次性加载，还是异步
          'expanded_first': false,//是否已经展开树节点
          'core': {
            "themes": {
              "responsive": false
            },
            "force_text":me.forceText,//树节点使用text方式
            "multiple": me.multiple,  //不允许多选
            "check_callback": function(operation, node, node_parent, node_position, more){
                return me.checkCallback(operation, node, node_parent, node_position, more);
            },
            'data': data
          },
          'checkbox': {
            "keep_selected_style": false,
            "tie_selection":true,
            "three_state": me.threeState,
            "visible": true
          },
          "plugins": plugin,
          "contextmenu": {
            "items": me.changeMenuItem
          },
          "types": types,
        }).bind("load_node.jstree", function (e, data) {
          let inst = data.instance;
          let set = inst.settings;
          if ((!set.async || set.async && me.propAsyncLoadOnce) && me.expandedFirst && !set.expanded_first) {
            function open_first_node(node) {
              if (node.children && node.children[0]) {
                let n = inst.get_node(node.children[0]);
                inst.open_node(n);
                open_first_node(n);
              } else {
                set.expanded_first = true;
                if (!me.multiple && me.selectFirst) {
                  inst.select_node(node)
                }
              }
            }
            open_first_node(data.node);
          }
          if(me.selecteNodeIds.length > 0){
            var setSelTreeNode=function(parentNode){
              if(me.selecteNodeIds.length > 0){
                var nodeId =  me.selecteNodeIds[me.selecteNodeIds.length - 1];
                var selNodeObj = inst.get_node(nodeId);
                if(selNodeObj){
                  inst.deselect_all();
                  inst.select_node(selNodeObj);
                  me.selecteNodeIds.pop();
                  setSelTreeNode(selNodeObj);
                }else{
                  if(data.node.id != "#"){
                    me.selecteNodeIds.pop();
                    if(me.selecteNodeIds.length===0){
                      me.$emit('changed', me.getSelected(),me);  //删除节点后没有选中的节点，所以在这里添加触发changed事件
                    }
                  }else{
                    if(parentNode.children.length > 0){
                      me.selecteNodeIds = [];
                      me.$emit('changed', me.getSelected(),me);  //删除节点后没有选中的节点，所以在这里添加触发changed事件
                    }
                  }
                }
              }
            }
              var nodeId = me.selecteNodeIds.pop();
              selNodeObj = inst.get_node(nodeId);
              if(selNodeObj){
                inst.deselect_all();
                inst.select_node(selNodeObj);
                inst.open_node(nodeId);
                setSelTreeNode(selNodeObj);
                set.expanded_first = true;
              }
          }else if (set.async && me.expandedFirst) {
            if (data.node && data.node.children && !set.expanded_first) {
              if (me.checkNodes.length > 0) {
                me.checkNodes.forEach(id => {
                  let obj = inst.get_node(id);
                  inst.check_node(obj);
                })
              }
              let node = inst.get_node(data.node.children[0]);
              if (node.original && node.original.hasChild > 0) {
                inst.open_node(data.node.children[0]);
              } else {
                if(me.selectFirst){
                  var selNodeObj = false;
                  if (me.selectNode) {
                    selNodeObj = inst.get_node(me.selectNode);
                  }
                  if(selNodeObj){
                    inst.select_node(selNodeObj);
                  }else{
                    inst.select_node(node)
                  }
                }
                set.expanded_first = true;
              }
            } else {
              set.expanded_first = true;
            }
          }
        }).on("changed.jstree", function (e, data) {
          let inst = data.instance;
          if (data.action == 'select_node') {
            if((!me.multiple && me.singleLeaf && data.node.original &&  data.node.original.hasChild>0)
              || me.multiple && me.multipleLeaf && !me.parentSelChildren && data.node.original &&  data.node.original.hasChild>0
            ){
              let obj = inst.get_node(data.node.original.id);
              inst.deselect_node(obj);
              return;
            }
            if (me.contextMenuItem.length > 0) {
              me.selectData = data.node.original;
              let parents = data.node.parents;
              me.selectParents = [];
              parents.forEach(id => {
                if ('#' != id) {
                  let obj = inst.get_node(id);
                  me.selectParents.push(obj.original);
                }
              })
              me.$emit('contextMenuChanged', data.node.original,inst.settings);
            }
            if(me.selecteNodeIds.length===0){
               me.$emit('changed', data.node.original,me);  //刷新树最后一次才触发，要不然表格会加载多次，会导致数据错乱
            }else{
              if(me.selecteNodeIds.length==1 &&data.node && (!data.node.children || data.node.children.length===0)){
                me.$emit('changed', data.node.original,me);
              }
            }
          }else if(data.action=="deselect_node"){
            me.$emit('unselected', data.node.original,me);
          }
        }).on("before_open.jstree", function (el,data) {

        }).bind("loaded.jstree", function (e, data) {
          let inst = data.instance;
          if (me.checkNodes.length > 0) {
            me.checkNodes.forEach(id => {
              let obj = inst.get_node(id);
              inst.check_node(obj);
            })
          }
          if (me.selectNode) {
            let obj = inst.get_node(me.selectNode);
            inst.select_node(obj);
          }
          me.$emit('loaded_tree', inst);
        }).bind("dblclick.jstree", function(e, data) {
          var id=e.target.id.substr(0,e.target.id.lastIndexOf('_'));
          var obj =  jsTreeEl.jstree(true).get_node(id);
          if (obj) {
            me.$emit("dblClick",obj.original,obj.parent);
          }
        }).on('show_contextmenu.jstree', function(e,data){
          let inst = data.instance;
          me.$emit('showContextmenu', data.node.original,inst.settings);
        }).on('move_node.jstree', function(e,data){
          me.$emit('move', e,data);
        }).on('ready.jstree', function(e,data){
          me.$emit('ready', e,data,me);
          if(me.propTreeData){
            let inst = data.instance;
            if (me.checkNodes.length > 0) {
              me.checkNodes.forEach(id => {
                let obj = inst.get_node(id);
                inst.check_node(obj);
              })
            }
            if (me.selectNode) {
              let obj = inst.get_node(me.selectNode);
              inst.select_node(obj);
            }

            if(me.expandedFirst){
              function open_first_node(node) {
                if(!node) return;
                if (node.children[0]) {
                  let n = inst.get_node(node.children[0]);
                  inst.open_node(n);
                  open_first_node(n);
                }else {
                  if(!me.selectNode && me.selectFirst){ //add by stt 2018/5/2 默认选中第一个
                    inst.select_node(node)
                  }
                }
              }
              if(me.propTreeData.length>0){
                let obj = inst.get_node(me.propTreeData[0].id);
                inst.open_node(obj);
                open_first_node(obj);
              }
            }
            if(me.parentSelChildren){
              jsTreeEl.delegate("a.jstree-anchor",'mousedown', function (e) {
                var id = this.id;
                let inst =jsTreeEl.jstree(true)
                var obj = inst.get_node(id);
                if(obj.children && obj.children.length > 0){
                  if (obj.state.selected != undefined) {
                    function open_node_and_check(node) {
                      inst.open_node(node);
                      var children=node.children;
                      if(children && children.length > 0){
                        children.map(v=>{
                          let n = inst.get_node(v);
                          inst.open_node(n);
                          open_node_and_check(n);
                        })
                      }else{
                        if(obj.state.selected){
                          inst.deselect_node(node)
                        }else{
                          inst.select_node(node)
                        }
                      }
                    }
                    open_node_and_check(obj);
                  }
                }
              })
            }
          }
          if(me.search){
            me.searchTree(me.searchText);
          }
        }).on('refresh.jstree', function(e,data){
          me.$emit('refresh', e,data,me);
        })


      },
    }
  }
</script>
<style >
  .mw-tree-select .mw-tree .icon-yellow{
    color: yellow;
  }
  .mw-tree-select .mw-tree .icon-green{
    color: green;
  }
  .mw-tree-select .mw-tree .icon-grey{
    color: grey;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/tree/index.vue